/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2025-02-28 14:46:19
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-02-28 16:49:05
 */
'use client';
import React, { useEffect, memo } from 'react';
import { eventBus } from '@ssv-website/hooks';

// 传递
export const EventEmit = memo((props: { message?: any; eventKey: string }) => {
  const { message = null, eventKey } = props;

  useEffect(() => {
    eventBus.emit<any>(eventKey, message);
    return () => {
      eventBus.emit<any>(eventKey, null);
    };
  }, [message]);

  return <></>;
});

// 接收
export const EventOn = memo(
  (props: { callback: (data: any) => void; eventKey: string }) => {
    const { callback, eventKey } = props;

    useEffect(() => {
      const handleMessage = (data: any) => {
        callback(data);
      };
      // 订阅事件
      eventBus.on<string>(eventKey, handleMessage);
      return () => {
        eventBus.off<string>(eventKey, handleMessage);
      };
    }, []);

    return <></>;
  }
);
